import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ReactNode, createContext, useEffect, useState } from 'react';

type DrawerContextType = {
  open: boolean;

  setOpen: (open: boolean) => void;
  desktop: boolean;
};

export const DrawerContext = createContext<DrawerContextType | null>(null);

function DrawerContextProvider({ children }: { children: ReactNode }) {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('sm'));

  const [open, setOpen] = useState(() => {
    const savedOpen = sessionStorage.getItem('layoutDrawerOpen');
    return savedOpen !== null ? JSON.parse(savedOpen) : desktop;
  });

  useEffect(() => {
    sessionStorage.setItem('layoutDrawerOpen', JSON.stringify(open));
  }, [open]);

  return (
    <DrawerContext.Provider
      value={{
        open,
        setOpen,
        desktop,
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
}

export default DrawerContextProvider;
